import React from 'react';
import { Layout } from 'antd';
import './PageLayout.css';

const { Content } = Layout;

export const PageLayout = ({ children, maxWidth = 600, fullWidth = false }) => {
  return (
    <Layout className="page-layout">
      <Content
        className="page-content"
        style={{ maxWidth: fullWidth ? 900 : maxWidth }}
      >
        {children}
      </Content>
    </Layout>
  );
};
